module.exports = __webpack_public_path__ + "img/2-4.9a50c2b5.svg";